import React from 'react';
import {Image, View} from 'react-native';

export default class extends React.Component {
    render() {
        return <View style={this.props.containerStyle || {}}>
            <Image source={this.props.uri} style={this.props.imageContainerStyle || {}}></Image>
        </View>
    }
}